import { removeUndefinedPropertiesFromObject, LinkCreationService } from '@sportal365/smp-widget-utils';
import { ICountry, ITennisCompetition, ITennisConfig } from '../../../../packages/types';
import { TARGET_BLANK, TARGET_SELF } from '../../../../packages/constants/windowTarget';
import { NOT_AVAILABLE } from '../../../../packages/constants/notAvailable';
import { assetsPlaceholder } from '../../../../packages/constants/assetsPlaceholder';
import { COMPETITION_ENTITY } from '../../../../packages/constants/entityTypes';

interface INormalizeCompetitionDataArgs {
  competition?: ITennisCompetition;
  dataEntityLinks?: ITennisConfig['dataEntityLinks'];
}

export const normalizeCompetitionData = ({ competition, dataEntityLinks }: INormalizeCompetitionDataArgs) => {
  if (!competition) return;

  const linkService = dataEntityLinks && new LinkCreationService(dataEntityLinks);
  const target = dataEntityLinks?.configuration?.newWindow ? TARGET_BLANK : TARGET_SELF;

  return removeUndefinedPropertiesFromObject({
    id: competition?.id,
    name: competition?.name ? competition.name : NOT_AVAILABLE,
    slug: competition?.slug,
    logo: competition?.assets?.logo?.url ?? assetsPlaceholder.competition,
    type: competition?.entityType,
    link: linkService?.createEntityUrl(String(competition?.id), COMPETITION_ENTITY, '', competition?.slug) ?? '#',
    urlTarget: target,
    assets: competition?.assets ?? assetsPlaceholder.competition,
    country: {} as ICountry,
    region: '',
  });
};
